// extracted by mini-css-extract-plugin
export default {"container":"SideMenuGroup_container__eptRi","link":"SideMenuGroup_link__vR2Ce","icon":"SideMenuGroup_icon__ddbPF"};